import { io } from "socket.io-client";
import { API_BASE } from "../api/config";
import { JOB_ROOM_PREFIX } from "../constants/payment";
import type { PaymentEvent } from "../types/payment";
import type { PaymentSocketHandlers, SocketAuth, SocketHandle } from "../types/socket";

const connectPaymentSocket = (paymentLogId: number, handlers: PaymentSocketHandlers, auth?: SocketAuth): SocketHandle => {
  const socket = io(API_BASE, {
    transports: ["websocket"],
    withCredentials: true,
    auth,
  });

  socket.on("connect", () => {
    socket.emit("join", `${JOB_ROOM_PREFIX}${paymentLogId}`);
    handlers.onConnected?.();
  });

  socket.on("message", (data: unknown) => {
    handlers.onMessage(data as PaymentEvent);
  });

  socket.on("connect_error", () => {
    handlers.onError("Connection failed");
  });

  return { disconnect: () => socket.disconnect() };
};

export { connectPaymentSocket };
